export enum IntegrationType {
    FastApi = "fastapi",
    Other = "other",
}
